import { createApp } from "vue";
import App from "./App.vue";
import currencyDirective from "./currencyDirective";
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";
import store from "./store";
import "./index.css";

const app = createApp(App);
app.use(store);
app.use(router);

app.directive("currency", currencyDirective);

app.use(VueAxios, axios);

// Restore a previously saved estimate before the first view renders.
store.dispatch("services/restoreEstimate");

app.mount("#app");
